import { useState } from "react";
import Cookies from "js-cookie";
import AuthenticationContext from "./AuthenticationContext";
import { useEffect } from "react";
// admin access level: [5, 7, 8, 9, 10, 11, 12]
// customer access level : [13,14,15,16]
interface UserInformation {
  token: string;
  fullName: string;
  userType: number;
  mobile: number;
  profilePicture: string | undefined;
  userName: string;
  accessLevel: number[];
}
export default function Authentication({ children }: { children: JSX.Element }) {
  const [userInfo, setUserInfo] = useState<UserInformation>({ token: "", fullName: "", userType: -1, mobile: 0, profilePicture: "", userName: "", accessLevel: [13, 14, 15, 16, 5, 7, 8, 9, 10, 11, 12] });

  const [isLogged, setIsLogged] = useState<boolean>(true);

  useEffect(() => {
    checkCookie();
  }, []);

  function login(token: string, fullName: string, userType: number, mobile: number, profilePicture: string | undefined, userName: string, accessLevel: number[]): void {
    if (token) {
      // to do : fix userType
      setUserInfo({ token, fullName, userType: 1, mobile, profilePicture, userName, accessLevel: [13, 14, 15, 16, 5, 7, 8, 9, 10, 11, 12] });

      setIsLogged(true);
      Cookies.set("token", token);
      Cookies.set("fullName", fullName);
      Cookies.set("userType", 1);
      Cookies.set("mobile", mobile);
      Cookies.set("profilePicture", profilePicture);
      Cookies.set("userName", userName);
      Cookies.set("accessLevel", [13, 14, 15, 16, 5, 7, 8, 9, 10, 11, 12]);
    }
  }

  function logout(): void {
    setUserInfo({ token: "", fullName: "", userType: -1, mobile: 0, profilePicture: "", userName: "", accessLevel: [] });
    setIsLogged(false);
    Cookies.remove("token");
    Cookies.remove("fullname");
    Cookies.remove("mobile");
    Cookies.remove("userType");
    Cookies.remove("profilePicture");
    Cookies.remove("userName");
    Cookies.remove("accessLevel");
  }

  function checkCookie(): void {
    login(Cookies.get("token"), Cookies.get("fullname"), Cookies.get("userType"), Cookies.get("mobile"), Cookies.get("profilePicture"), Cookies.get("userName"), Cookies.get("accessLevel"));
  }

  return (
    <>
      <AuthenticationContext.Provider
        value={{
          login,
          userInfo,
          isLogged,
          logout,
        }}
      >
        {children}
      </AuthenticationContext.Provider>
    </>
  );
}
